<div class="chartjs-wrapper">
    <canvas #chart class="chartjs">{{chart}}</canvas>
</div>
